<template>
  <div
    class="notification"
    :class="success ? 'is-success' : 'is-danger'"
    :data-error-code="error.status">

    <button class="delete" @click="dismiss"></button>
    <span class="icon"><strong><i class="fas fa-exclamation-triangle"></i></strong></span>
    <div class="content" v-html="message"></div>
    <hr id="progress" :class="{ 'animate': animate }">
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      error: 'http/error'
    }),
    success () {
      return (this.error.status >= 200 && this.error.status < 300)
    },
    message () {
      if (this.error.errors) {
        let messages = []

        for (let error in this.error.errors) {
          messages.push(this.error.errors[error])
        }

        return messages.join('<br>')
      } else {
        let error = this.errors.find((x) => {
          return x.code === this.error.status
        })

        if (error) {
          return error.message
        }

        return 'Er was een onbekend probleem bij het verwerken van de aanvraag.'
      }
    }
  },
  data () {
    return {
      animate: false,
      errors: [
        {
          code: 401,
          message: 'Geen geldige login gevonden.'
        },
        {
          code: 429,
          message: 'Er vinden te veel aanvragen plaats op de server. Probeer het later nogmaals.'
        },
        {
          code: 403,
          message: 'Deze functie vereist een ander gebruikersniveau.<br>Neem contact op met de beheerder om uw gebruikersrechten te wijzigen en toegang te krijgen.'
        },
        {
          code: 404,
          message: 'Het verzoek is niet bekend op de server.'
        },
        {
          code: 406,
          message: 'Login gegevens ongeldig'
        },
        {
          code: 503,
          message: 'De server is niet beschikbaar of offline in verband met onderhoud.'
        }
      ]
    }
  },
  mounted () {
    setTimeout(() => {
      this.animate = true
    }, 500)

    setTimeout(() => {
      this.dismiss()
    }, 3500)
  },
  methods: {
    dismiss () {
      this.$store.dispatch('http/dismissError')
    }
  }
}
</script>

<style scoped>
  .notification {
    position: fixed;
    right: 15px;
    top: 15px;
    margin: 0 auto;
    z-index: 500;
  }

  .notification #progress {
    width: 0;
    transition: width 3s ease-in-out
  }

  .notification #progress.animate {
    width: 100%;
  }
</style>
